import { render, staticRenderFns } from "./NavBarSupplierPerformance.vue?vue&type=template&id=4a2ac1d2"
import script from "./NavBarSupplierPerformance.vue?vue&type=script&lang=js"
export * from "./NavBarSupplierPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports